import { ErrorTypes, QuestionType } from 'shared-domains';
import $i18n from '~/services/i18n';

const defaultMessages = {
  [ErrorTypes.MIN_OPTIONS]: $i18n('Add at least two options'),
  [ErrorTypes.MAX_OPTIONS]: $i18n('Only 5 options are allowed'),
  [ErrorTypes.EMPTY_QUERY]: $i18n('Please enter a question'),
  [ErrorTypes.QUERY_IMAGE]: $i18n('Please add an image'),
  [ErrorTypes.INVALID_ANSWER]: $i18n('Please select a correct answer'),
};
const ValidationMessages: Record<string, any> = {
  [QuestionType.MCQ]: {
    ...defaultMessages,
  },
  [QuestionType.MSQ]: {
    ...defaultMessages,
  },
  [QuestionType.OPEN]: {
    ...defaultMessages,
  },
  [QuestionType.WORDCLOUD]: {
    ...defaultMessages,
  },
  [QuestionType.BLANK]: {
    ...defaultMessages,
    [ErrorTypes.INVALID_ANSWER]: $i18n('Please add the correct answer'),
  },
  [QuestionType.MATCH]: {
    ...defaultMessages,
    [ErrorTypes.MIN_OPTIONS]: $i18n('Add at least three options corresponding to three matches'),
    [ErrorTypes.MIN_MATCHES]: $i18n('Add at least three matches corresponding to three options'),
    [ErrorTypes.MAX_MATCHES]: $i18n('Only 5 matches are allowed'),
    [ErrorTypes.EMPTY_CORRESPONDING_MATCHES_OR_OPTIONS]: $i18n('Some matches or options are empty'),
  },
  [QuestionType.REORDER]: {
    ...defaultMessages,
    [ErrorTypes.MIN_OPTIONS]: $i18n('Add at least three options'),
    [ErrorTypes.OPTIONS_ANSWERS_SAME_LENGTH]: $i18n('Number of options and answers should be same'),
  },
  [QuestionType.AUDIO]: {
    ...defaultMessages,
  },
  [QuestionType.VIDEO]: {
    ...defaultMessages,
  },
  [QuestionType.EQUATION]: {
    ...defaultMessages,
    [ErrorTypes.MIN_OPTIONS]: $i18n('Please enter the answer'),
    [ErrorTypes.INVALID_ANSWER]: $i18n('Please enter the answer'),
    [ErrorTypes.CUSTOM_ANSWER]: $i18n('Please enter valid equation'),
  },
  [QuestionType.HOTSPOT]: {
    ...defaultMessages,
    [ErrorTypes.MIN_OPTIONS]: $i18n('Add at least two hotspots'),
    [ErrorTypes.MAX_OPTIONS]: $i18n('Only 10 hotspots are allowed'),
    [ErrorTypes.INVALID_ANSWER]: $i18n('Please select the answer'),
  },
  [QuestionType.DND_IMAGE]: {
    ...defaultMessages,
    [ErrorTypes.MAX_OPTIONS]: $i18n('Only 10 options are allowed'),
  },
  [QuestionType.DRAW]: {
    ...defaultMessages,
  },
  [QuestionType.DRAGNDROP]: {
    ...defaultMessages,
    [ErrorTypes.MAX_OPTIONS]: $i18n('Only 10 options are allowed'),
    [ErrorTypes.INVALID_ANSWER]: $i18n('Add at least one blank'),
  },
  [QuestionType.DROPDOWN]: {
    ...defaultMessages,
    [ErrorTypes.MAX_OPTIONS]: $i18n('Only 10 options are allowed'),
    [ErrorTypes.INVALID_ANSWER]: $i18n('Add at least one blank'),
  },
  [QuestionType.GRAPHING]: {
    ...defaultMessages,
    [ErrorTypes.EMPTY_GRAPH]: $i18n('Please select a graph equation type'),
    [ErrorTypes.MIN_POINTS]: $i18n('Plot at least one point'),
  },
  [QuestionType.CLASSIFICATION]: {
    ...defaultMessages,
    [ErrorTypes.MAX_OPTIONS]: $i18n('Only 20 options are allowed'),
    [ErrorTypes.MIN_TARGETS]: $i18n('Add at least 2 categories with at least one option in each category'),
    [ErrorTypes.EMPTY_CATEGORY]: $i18n('Please add name to the category which has option(s)'),
    [ErrorTypes.DUPLICATE_CATEGORY]: $i18n('Please remove the duplicate category or rename'),
  },
  [QuestionType.COMPREHENSION]: {
    [ErrorTypes.MIN_QUESTIONS]: $i18n('Add at least 1 question'),
    [ErrorTypes.EMPTY_QUERY]: $i18n('Please add comprehension text or a document'),
  },
  [QuestionType.COMPREHENSION_VIDEO]: {
    [ErrorTypes.MIN_QUESTIONS]: $i18n('Add at least 1 question'),
    [ErrorTypes.EMPTY_QUERY]: $i18n('Please add a video'),
  },
};

export const defaultErrorMessage = $i18n('Something is missing in this question');

export default ValidationMessages;
